module.exports = __webpack_public_path__ + "images/emoji/icecream.c985ce872c4b92b9174f.png";